import { render, staticRenderFns } from "./BookDetails.vue?vue&type=template&id=619617cf&scoped=true"
import script from "./BookDetails.vue?vue&type=script&lang=js"
export * from "./BookDetails.vue?vue&type=script&lang=js"
import style0 from "./BookDetails.vue?vue&type=style&index=0&id=619617cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619617cf",
  null
  
)

export default component.exports